import { render } from "./LangPrefs.vue?vue&type=template&id=316b3a6c&scoped=true&ts=true"
import script from "./LangPrefs.vue?vue&type=script&lang=ts"
export * from "./LangPrefs.vue?vue&type=script&lang=ts"

import "./LangPrefs.vue?vue&type=style&index=0&id=316b3a6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316b3a6c"]])

export default __exports__